import React from 'react';
import { FilteredLayer, LayerTypes } from '../features/geo-info/types/map-layer';
import { LayerFilter } from './filter-layers';

type Props = {
  title: string;
  onClose: () => void;
  selectedLayers: string[];
  onAdd: (layer: FilteredLayer) => void;
};

export const FolderFilter = (props: Props): JSX.Element => {
  return <LayerFilter { ...props } type={LayerTypes.FOLDER} />;
};
